import type { Hotel, WithContext } from 'schema-dts'
import { useCMSPageField } from '@/cms/fields'
import { stripHtmlTags } from '@/scopes/products/pages/components/Description/utils'

export function usePDPStructuredMarkup() {
  const url = useCMSPageField('PDP.url')
  const title = useCMSPageField('PDP.title')
  const description = stripHtmlTags(useCMSPageField('PDP.description'))
  const media = useCMSPageField('PDP.media')
  const coordinates = useCMSPageField('PDP.coordinates')
  const ratingsCount = useCMSPageField('userReviews.ratingsCount')
  const ratingAverage = useCMSPageField('userReviews.ratingAverage')
  const shouldShowRatings = useCMSPageField('userReviews.shouldShowRatings')
  const starRating = useCMSPageField('PDP.rating')

  const jsonLd: WithContext<Hotel> = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    'name': title,
    description,
    'url': (process.env.NEXT_PUBLIC_BASE_URL ?? 'https://www.sunweb.nl') + url,
    // We assume first media is an image
    'image': (media && media.length) > 0 ? media[0].src : '',
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': coordinates.lat,
      'longitude': coordinates.lng,
    },
    'starRating': {
      '@type': 'Rating',
      'ratingValue': starRating,
    },
  }

  if (shouldShowRatings) {
    jsonLd.aggregateRating = {
      '@type': 'AggregateRating',
      'bestRating': 10,
      'worstRating': 0,
      'ratingValue': ratingAverage,
      'reviewCount': ratingsCount,
    }
  }

  return jsonLd
}
